import React from "react";
import { COMPANY } from "@/data/site";

// Official Google Play badge (SVG-based) sized for dark backgrounds.
export default function GooglePlayBadge({ className = "", testId = "google-play-badge" }) {
  return (
    <a
      href={COMPANY.playStore}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label="Get it on Google Play"
      className={`inline-flex items-center gap-3 border border-white/20 bg-black px-4 py-2.5 hover:border-[#e63946] transition-colors ${className}`}
    >
      <svg width="22" height="24" viewBox="0 0 512 512" aria-hidden="true" className="flex-shrink-0">
        <path fill="#00d0ff" d="M47 20 300 256 47 492c-9-5-15-15-15-27V47c0-12 6-22 15-27z" />
        <path fill="#00f076" d="M47 20c4-2 9-3 14-3 6 0 12 2 17 5l248 143-73 73L47 20z" />
        <path fill="#ffd500" d="M420 213l-79-46-78 78 78 78 79-46c22-13 22-51 0-64z" />
        <path fill="#ff3a44" d="M326 335 78 478c-5 3-11 5-17 5-5 0-10-1-14-3l253-218 26 73z" />
      </svg>
      <span className="text-left leading-none">
        <span className="block font-mono text-[9px] uppercase tracking-[0.2em] text-zinc-400">
          Get it on
        </span>
        <span className="block font-display text-sm uppercase tracking-tight text-white mt-0.5">
          Google Play
        </span>
      </span>
    </a>
  );
}
